export const moreInfoLabel = bfTranslate('More info');
export const genericError = bfTranslate('Oops! Something went wrong.');